import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import { format } from "date-fns";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useRetrieveUserIntraSquadMatchPermissions } from "../api/PermissionApiProvider";
import { useRetrieveIntraSquadMatch, useRetrieveTeam, useRetrieveTeamPreferences, useSubmitIntraSquadMatchStats, } from "../ApiProvider";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import { NotFound } from "../nav/NotFound";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { useNumericParams } from "../utils/useNumericParams";
import { IntraSquadMatchStatsForm, } from "./IntraSquadMatchStatsForm";
export const UpdatePlayerIntraSquadMatchStats = () => {
    const { id } = useNumericParams();
    const { data: userIntraSquadMatchPermissions, isLoading: userIntraSquadMatchPermissionsIsLoading, error: userIntraSquadMatchPermissionsError, } = useRetrieveUserIntraSquadMatchPermissions({ intraSquadMatchId: id });
    const { canModify = false, canModifyStats = false } = userIntraSquadMatchPermissions || {};
    const canEditStats = canModify || canModifyStats;
    const { isLoading: useRetrieveIntraSquadMatchIsLoading, error: useRetrieveIntraSquadMatchError, data: intraSquadMatch, } = useRetrieveIntraSquadMatch({ id, enabled: canEditStats });
    const { isLoading: isTeamLoading, error: teamError, data: team, } = useRetrieveTeam({ id: intraSquadMatch?.team });
    const { data: teamPreferences, error: teamPreferencesError, isLoading: teamPreferencesIsLoading, } = useRetrieveTeamPreferences({ teamId: intraSquadMatch?.team });
    const navigate = useNavigate();
    const { isLoading: submitStatsIsLoading, isError: submitStatsIsError, mutate: submitStats, } = useSubmitIntraSquadMatchStats(intraSquadMatch);
    if (userIntraSquadMatchPermissionsIsLoading) {
        return _jsx(Loading, {});
    }
    if (userIntraSquadMatchPermissionsError) {
        return _jsx(ErrorView, { error: userIntraSquadMatchPermissionsError });
    }
    if (teamError) {
        return _jsx(ErrorView, { error: teamError });
    }
    if (!canEditStats) {
        return _jsx(NotFound, {});
    }
    if (teamPreferencesIsLoading ||
        useRetrieveIntraSquadMatchIsLoading ||
        isTeamLoading ||
        !intraSquadMatch) {
        return _jsx(Loading, {});
    }
    const onSubmit = (intraSquadMatchResult, playerIntraSquadMatchStats) => {
        submitStats({
            result: {
                teamAScore: intraSquadMatchResult.teamAScore,
                teamBScore: intraSquadMatchResult.teamBScore,
                matchReport: intraSquadMatchResult.matchReport,
            },
            playerStats: playerIntraSquadMatchStats,
        }, {
            onSuccess: () => navigate(`/teams/${intraSquadMatch.team}/intra-squad-matches/${id}/`),
        });
    };
    if (!teamPreferences ||
        useRetrieveIntraSquadMatchError ||
        teamPreferencesError) {
        return (_jsx(ErrorView, { error: useRetrieveIntraSquadMatchError || teamPreferencesError }));
    }
    if (!team) {
        return _jsx(ErrorView, { error: new Error("Could not load team!") });
    }
    return (_jsxs(React.Fragment, { children: [_jsx(ErrorSnackbar, { open: submitStatsIsError, message: "Failed to save intra-squad match stats! Please try again." }), _jsx(Typography, { variant: "h6", children: _jsxs("strong", { children: ["Intra-Squad Match Stats for ", team.name] }) }), _jsx(Typography, { variant: "subtitle2", children: format(new Date(intraSquadMatch.kickOff), "MMMM do yyyy @ H:mma") }), _jsx(IntraSquadMatchStatsForm, { onSubmit: onSubmit, intraSquadMatch: intraSquadMatch, teamPreferences: teamPreferences, isSubmitting: submitStatsIsLoading })] }));
};
